import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { ISuccessCaseProps, SuccessCase } from './SuccessCase/SuccessCase';

import s from './SuccessCases.scss';

const glovoCase: ISuccessCaseProps = {
	logo: 'glovo-logo',
	title: ['Impact study:', 'Rewriting Futures for Glovo’s Couriers'],
	text: [
		{
			segments: [
				'“We introduced Sololearn to help couriers venture into coding. The response was ',
				'overwhelming! ',
				'What makes Sololearn’s educational content unique is the ',
				'gamified ',
				'experience that ',
				'rewards ',
				'couriers, and its ',
				'bite-size content ',
				'allowed couriers to utilize breaks and evenings to ',
				'learn something new in just 3 minutes. ',
				'Groups became a hub for sharing insights, clarifying doubts, and ',
				'fostering a community ',
				'where couriers supported and ',
				'motivated each other. ',
				'It was a testament to our strong sense of ',
				'camaraderie.”',
			],
			boldKeys: [1, 3, 5, 7, 9, 11, 13, 15],
			onlyDesktop: true,
		},
		{
			segments: ['– Christina Gama, ', 'Glovo'],
			boldKeys: [1],
			onlyDesktop: true,
		},
		{
			segments: [
				'In June 2023, Glovo introduced Sololearn, getting an overwhelming response, with over 300 couriers from five different countries enrolling in the program and ready to dive into the world of coding head first.',
			],
			onlyMobile: true,
		},
	],
	image: 'teams-glovo-courier',
	metrics: [
		[
			{
				value: '100%',
				type: 'enrolled and took lessons',
			},
			{
				value: '80%',
				type: 'remained engaged completing lessons',
			},
		],
		[
			{
				value: '24,000+',
				type: 'lessons successfully completed',
			},
			{
				value: '170+',
				type: 'course certificates awarded',
			},
		],
	],
	cta: 'Read the full story',
	link: 'https://about.glovoapp.com/stories/rewriting-futures-with-sololearn/',
};

export function SuccessCases() {
	useStyles(s);
	return (
		<div className="sl-teams-success-cases">
			<SuccessCase {...glovoCase} />
		</div>
	);
}
